import { getCalcInputState } from "../../../../../utils/selectors";
import { hangerSlice } from './slice'

export const getHangerState = (state) => getCalcInputState(state)[hangerSlice.name];
